import React, { useState, useRef, useEffect } from "react";
import "./index.css";
import capaVideo from "../../assets/images/png/capaVideo.png";

export default function Video() {
  const [showVideo, setShowVideo] = useState(false);
  const containerRef = useRef(null);
  const youtubeVideoId = "BXdSFH1GL3I";

  const handleClick = () => {
    if (!showVideo) {
      setShowVideo(true);
    }
  };

  useEffect(() => {
    const options = {
      root: null,
      rootMargin: "0px",
      threshold: 0.5,
    };

    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) {
          setShowVideo(false);
        }
      });
    }, options);

    if (containerRef.current) {
      observer.observe(containerRef.current);
    }

    return () => {
      if (containerRef.current) {
        observer.unobserve(containerRef.current);
      }
    };
  }, []);

  return (
    <div className="video-container">
      <div className="container">
        <div className="row d-flex justify-content-center" style={{ padding: "5% 0" }}>
          <div className="col-md-12" style={{ width: "100%" }}>
            <div className="position-relative" ref={containerRef}>
              {/* <img
                className="borda-video"
                style={{
                  zIndex: 10,
                  position: "absolute",
                  transform: "translate(-50%, -50%)",
                  top: "52%",
                  left: "49%",
                  width: "110%",
                  height: "105%",
                  opacity: "0.25",
                  filter: "brightness(0)",
                  pointerEvents: "none",
                }}
                src={bordaVideo}
                alt="borda do video"
              /> */}
              <div
                style={{
                  position: "relative",
                  width: "100%",
                  borderRadius: "20px",
                  overflow: "hidden",
                  boxShadow: "-10px 10px 0px 0px rgba(0, 0, 0, 0.5)",
                  aspectRatio: "16/9",
                  backgroundColor: "#000",
                }}
              >
                {/* Imagem de capa - visível quando showVideo é false */}
                <img
                  onClick={handleClick}
                  style={{
                    position: "absolute",
                    top: 0,
                    left: 0,
                    width: "100%",
                    height: "100%",
                    objectFit: "cover",
                    borderRadius: "10px",
                    cursor: "pointer",
                    opacity: showVideo ? 0 : 1,
                    transition: "opacity 0.3s ease-in-out",
                    pointerEvents: showVideo ? "none" : "auto",
                    zIndex: showVideo ? 1 : 2,
                  }}
                  className="capa-video"
                  src={capaVideo}
                  alt="capa do video"
                />

                {/* Iframe do YouTube - sempre renderizado, muda src quando showVideo muda para iniciar autoplay */}
                <iframe
                  key={showVideo ? "youtube-video-play" : "youtube-video-preload"}
                  style={{
                    position: "absolute",
                    top: 0,
                    left: 0,
                    width: "100%",
                    height: "100%",
                    borderRadius: "10px",
                    border: "none",
                    opacity: showVideo ? 1 : 0,
                    transition: "opacity 0.2s ease-in-out",
                    pointerEvents: showVideo ? "auto" : "none",
                    zIndex: showVideo ? 2 : 1,
                    visibility: showVideo ? "visible" : "hidden",
                  }}
                  className="video-content"
                  src={showVideo 
                    ? `https://www.youtube.com/embed/${youtubeVideoId}?rel=0&autoplay=1&mute=0` 
                    : `https://www.youtube.com/embed/${youtubeVideoId}?rel=0&autoplay=0&mute=0`
                  }
                  title="YouTube video player"
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                  allowFullScreen
                />
              </div>
              {/* <img
                className="borda-video"
                style={{
                  zIndex: 30,
                  position: "absolute",
                  transform: "translate(-50%, -50%)",
                  top: "50%",
                  left: "50%",
                  width: "110%",
                  height: "105%",
                  pointerEvents: "none",
                }}
                src={bordaVideo}
                alt="borda do video"
              /> */}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
